import { TFunction } from "i18next";

export const statusColumnOptions = (t: TFunction<"global", undefined>) => [
  {
    value: "deleted",
    label: t("Data.table.manage_status_columns.141"),
    description: t("Data.table.manage_status_columns_desc.141"),
    id: 141,
  },
  {
    value: "abortedNoValidated",
    label: t("Data.table.manage_status_columns.140"),
    description: t("Data.table.manage_status_columns_desc.140"),
    id: 140,
  },

  {
    value: "finishedWithErrors",
    label: t("Data.table.manage_status_columns.139"),
    description: t("Data.table.manage_status_columns_desc.139"),
    id: 139,
  },

  {
    value: "finishedIncomplete",
    label: t("Data.table.manage_status_columns.138"),
    description: t("Data.table.manage_status_columns_desc.138"),
    id: 138,
  },

  {
    value: "finishedComplete",
    label: t("Data.table.manage_status_columns.137"),
    description: t("Data.table.manage_status_columns_desc.137"),
    id: 137,
  },

  {
    value: "inProgress",
    label: t("Data.table.manage_status_columns.136"),
    description: t("Data.table.manage_status_columns_desc.136"),
    id: 136,
  },
];
